<div class="page-header-row">
  <div class="breadcrumb-wrap">
    <ul class="breadcrumbs">
      <li class="breadcrumb">My Media</li>
    </ul>
  </div>

  <div class="page-actions-wrap">
    <mat-icon *ngIf="canViewDraft !== true" class="page-action" matToolTip="Add New Album"></mat-icon>
    <mat-icon *ngIf="canViewDraft == true" class="page-action" matTooltip="Create New..." [matMenuTriggerFor]="collectionMenu">
      add
    </mat-icon>
    <mat-menu #collectionMenu>
      <button mat-menu-item (click)="newAlbumDialog()">Create New Album</button>
      <button mat-menu-item (click)="newGalleryDialog()">Create New Gallery</button>
    </mat-menu>
  </div>
</div>

<div class="page-content-row toggle-nav-wrap">
  <a class="toggle-nav-button" (click)="albumsToggle()" [ngClass]="{ 'toggle-nav-button-active': showAlbums == true }"> Albums </a>
  <a
    *ngIf="canViewDraft"
    class="toggle-nav-button"
    (click)="galleriesToggle()"
    [ngClass]="{ 'toggle-nav-button-active': showGalleries == true }"
  >
    Galleries
  </a>
  <div class="search-wrap">
    <!-- Search input -->
    <div class="tag-search-wrap">
      <div class="search-row">
        <input matInput type="search" [formControl]="searchText" placeholder="Search" name="search" (keyup)="onFilter_keyup($event)" />
        <div class="search-row-icon" (click)="clearSearch()" matTooltip="Clear Search">
          <i class="material-icons search-clear">close</i>
        </div>
      </div>
    </div>
  </div>
</div>

<app-albums *ngIf="showAlbums === true" [albums]="filteredAlbums" (selectAlbum)="onAlbumSelect($event)"> </app-albums>

<app-galleries
  *ngIf="showGalleries === true"
  [galleries]="filteredGalleries"
  [offices]="offices"
  [userOfficeId]="currentOffice$ | async"
  [showStatusFilter]="true"
  (selectGallery)="onGallerySelect($event)"
></app-galleries>

<scroll-to-top></scroll-to-top>
